import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import {
  TypePromiseAutoMark,
  TypePromiseAutoModel,
  TypePromiseAutoYear,
  TypePromiseAutoModification,
  listMark,
  listModel,
  listYear,
  listModify,
} from './TypePromise';

class ServiceAuto {
  async getAutoMarkFilter(): Promise<listMark[]> {
    return MyAxios.get<TypePromiseAutoMark>('/api/catalog/get-auto-mark').then(handleResponse).catch(handleError);
  }

  async getAutoModelFilter(markId: number): Promise<listModel[]> {
    return MyAxios.get<TypePromiseAutoModel>(`/api/catalog/get-auto-model?markId=${markId}`).then(handleResponse).catch(handleError);
  }

  async getAutoYearFilter(groupCode: string, markId: number): Promise<listYear[]> {
    return MyAxios.get<TypePromiseAutoYear>(`/api/catalog/get-auto-year?groupCode=${groupCode}&markId=${markId}`)
      .then(handleResponse)
      .catch(handleError);
  }

  async getAutoModificationFilter(modelId: number[]): Promise<listModify[]> {
    const strParams = '?' + modelId?.map(value => `modelId[]=${value}`).join('&');
    return MyAxios.get<TypePromiseAutoModification>(`/api/catalog/get-auto-modification${strParams}`).then(handleResponse).catch(handleError);
  }
}

const serviceAutoInstance = new ServiceAuto();

export default serviceAutoInstance;
